exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-list .img-wrap{position:relative;overflow:hidden;padding-bottom:60%}.report-list .img-wrap img{position:absolute;width:100%;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@media (max-width:768px){.report-list .img-wrap{height:190px;padding-bottom:unset}}@media (max-width:576px){.report-list .img-wrap{height:170px}.report-list .img-wrap img{width:70%!important;min-width:200px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ee6606b8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Qna/report.vue
// module id = 152
// module chunks = 0